import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M43.1199 1.08176V1.05176C42.9399 1.05176 42.7699 1.06177 42.5999 1.06177C42.4199 1.06177 42.2499 1.05176 42.0799 1.05176V1.08176C11.2099 1.64176 -1.91006 26.6318 2.03994 50.0518C6.03994 73.7318 24.5799 82.3018 24.5799 82.3018H60.6199C60.6199 82.3018 79.1599 73.7318 83.1599 50.0518C87.1099 26.6318 73.9899 1.64176 43.1199 1.08176Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
    </g>
  )
}
